import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import type { MyGeneratedMusicItem } from '~/types/generate'

type SongUpdater = Partial<MyGeneratedMusicItem> | ((song: MyGeneratedMusicItem) => MyGeneratedMusicItem)

export const useMySongsStore = defineStore('mySongsStore', () => {
  const songs = ref<MyGeneratedMusicItem[]>([])
  const total = ref(0)
  const page = ref(1)
  const pageSize = ref(20)
  const isLoading = ref(false)
  const refreshToken = ref(0)

  const pageCount = computed(() => Math.ceil(total.value / pageSize.value))

  const setSongs = (items: MyGeneratedMusicItem[] | null | undefined) => {
    songs.value = items ?? []
  }

  const setTotal = (value?: number | null) => {
    total.value = value ?? 0
  }

  const setPage = (value: number) => {
    page.value = value || 1
  }

  const setPageSize = (value: number) => {
    pageSize.value = value || 20
  }

  const setLoading = (value: boolean) => {
    isLoading.value = value
  }

  const triggerRefresh = (options?: { resetPage?: boolean }) => {
    if (options?.resetPage !== false) {
      setPage(1)
    }
    refreshToken.value += 1
  }

  const updateSong = (uuid: string | number | undefined, updater: SongUpdater) => {
    if (!uuid) return
    const index = songs.value.findIndex(song => song.uuid === uuid)
    if (index === -1) return

    const current = songs.value[index]
    const next = typeof updater === 'function' ? updater(current) : { ...current, ...updater }
    songs.value.splice(index, 1, next)
  }

  const removeSong = (uuid: string | number | undefined) => {
    if (!uuid) return
    songs.value = songs.value.filter(song => song.uuid !== uuid)
  }

  return {
    songs,
    total,
    page,
    pageSize,
    isLoading,
    refreshToken,
    pageCount,
    setSongs,
    setTotal,
    setPage,
    setPageSize,
    setLoading,
    triggerRefresh,
    updateSong,
    removeSong
  }
})

